import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { status } = useAuth();

  if (status === "loading") {
    return (
      <div
        data-testid="protected-loading"
        className="min-h-screen flex items-center justify-center speculo-grid-bg"
      >
        <div className="speculo-glass px-6 py-4 rounded-sm text-cyan-300 uppercase tracking-widest text-sm font-mono">
          Establishing secure link…
        </div>
      </div>
    );
  }

  if (status !== "authed") {
    return <Navigate to="/login" replace />;
  }

  return children;
}
